//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    elements: {
      type: Array,
      default: () => {},
    },
  },
}
